export default __webpack_public_path__ + "static/media/project_manager_2x.8e457cce.png";